import useAsyncData from "../../../../hooks/use-async-data";
import taxiCorporationService from "../../taxi-corporation.service";
import TaxiCorporationPlanEntryBillings from "./taxi-corporation-plan-entry-billings";
import TaxiCorporationPlanEntryBillingsParams from "./taxi-corporation-plan-entry-billings-params";

const useTaxiCorporationPlanEntryBillings = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<TaxiCorporationPlanEntryBillings | null>(null);

  const load = async (
    params: TaxiCorporationPlanEntryBillingsParams,
    abortSignal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await taxiCorporationService.getPlanEntryBillings(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useTaxiCorporationPlanEntryBillings;
